import { createFileRoute } from '@tanstack/react-router';
import { SellEndpoints } from '../../pages/sell/SellEndpoints';

export const Route = createFileRoute('/dashboard/sell/endpoints/')({ component: SellEndpoints });
